(function () {
  const gridSelector =
    '.ecom-collection__product-main.ecom-collection_product_template_collection .ecom-collection__product--wrapper-items';
  const itemClassName = 'ecom-collection__product-item';
  const flagSelector = '.roi-editorial-flag';
  const productCardSelector = '.ecom-collection__product-item';
  const titleSelector = '.ecom-collection__product-item-information-title';
  const soldOutBadgeSelector = '.ecom-collection__product-badge--sold-out';
  const soldOutLabelClass = 'roi-collection-out-of-stock';
  const requestFrame =
    window.requestAnimationFrame ||
    function (callback) {
      return window.setTimeout(callback, 16);
    };
  let isScheduled = false;

  function getColumnCount(grid) {
    const computedColumns = window.getComputedStyle(grid).gridTemplateColumns;

    if (computedColumns && computedColumns !== 'none') {
      return computedColumns
        .split(' ')
        .map(function (part) {
          return part.trim();
        })
        .filter(Boolean).length;
    }

    const fallbackColumns = parseInt(grid.dataset.gridColumn || '', 10);
    return Number.isFinite(fallbackColumns) ? fallbackColumns : 0;
  }


  function getFeaturedHandlesFromTheme() {
    const node = document.getElementById('roi-editorial-featured-handles');
    if (!node) return [];

    try {
      const parsed = JSON.parse(node.textContent || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function(handle) {
        return typeof handle === 'string' && handle.length > 0;
      });
    } catch (error) {
      return [];
    }
  }



  function injectCollectionFinalOverrides() {
    if (document.getElementById('roi-collection-final-overrides-v3')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'roi-collection-final-overrides-v3';
    style.textContent = `
      body .ecom-collection__product-main.ecom-collection_product_template_collection
        .ecom-collection__product-item .ecom-collection__product-item-information-title,
      body .ecom-collection__product-main.ecom-collection_product_template_collection
        .ecom-collection__product-item .ecom-collection__product-item-information-title a {
        font-family: Manrope, Manrope-VariableFont_wght, sans-serif !important;
        font-size: 16px !important;
        font-weight: 500 !important;
        line-height: 1.25em !important;
        letter-spacing: 0 !important;
        text-transform: none !important;
      }

      body .ecom-collection__product-main.ecom-collection_product_template_collection
        .ecom-collection__product-item .ecom-collection__product-price,
      body .ecom-collection__product-main.ecom-collection_product_template_collection
        .ecom-collection__product-item .ecom-collection__product-price a,
      body .ecom-collection__product-main.ecom-collection_product_template_collection
        .ecom-collection__product-item .ecom-collection__product-price--regular,
      body .ecom-collection__product-main.ecom-collection_product_template_collection
        .ecom-collection__product-item .ecom-collection__product-price--regular a,
      body .ecom-collection__product-main.ecom-collection_product_template_collection
        .ecom-collection__product-item .ecom-collection__product-price--sale,
      body .ecom-collection__product-main.ecom-collection_product_template_collection
        .ecom-collection__product-item .ecom-collection__product-price--sale a {
        font-family: Manrope, Manrope-VariableFont_wght, sans-serif !important;
        font-size: 16px !important;
        font-weight: 500 !important;
        line-height: 1.25em !important;
        letter-spacing: 0 !important;
      }



      /* roi-sort-button-uk-style: align FR sort control with UK visual treatment. */
      /* roi-sort-button-align-filters: reduced to match the Filters button size. */
      .ecom-collection__sorting-container {
        position: relative !important;
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        width: 187px !important;
        min-width: 187px !important;
        height: 43px !important;
        min-height: 43px !important;
        padding: 10px 44px 10px 20px !important;
        background: #f3f3f3 !important;
        border: 0 !important;
        border-radius: 0 !important;
        cursor: pointer !important;
        box-sizing: border-box !important;
      }

      .ecom-collection__sorting-container::after {
        content: "" !important;
        position: absolute !important;
        right: 20px !important;
        top: 50% !important;
        width: 8px !important;
        height: 8px !important;
        border-right: 1.5px solid #000 !important;
        border-bottom: 1.5px solid #000 !important;
        transform: translateY(-65%) rotate(45deg) !important;
        pointer-events: none !important;
      }

      .ecom-collection__sorting-container .ecom-collection__filters-heading {
        display: block !important;
        width: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        color: #000 !important;
        font-family: Manrope, Manrope-VariableFont_wght, sans-serif !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 1.2 !important;
        letter-spacing: 0 !important;
        text-transform: none !important;
        pointer-events: none !important;
      }

      .ecom-collection__sorting-container select[name="sort_by"].ecom-collection__sorting-select {
        position: absolute !important;
        inset: 0 !important;
        display: block !important;
        width: 100% !important;
        height: 100% !important;
        opacity: 0 !important;
        cursor: pointer !important;
        z-index: 5 !important;
      }

      .ecom-collection__sorting-container {
        position: relative !important;
        cursor: pointer !important;
      }

      .ecom-collection__sorting-container .ecom-collection__filters-heading {
        pointer-events: none !important;
      }

      .ecom-collection__sorting-container select[name="sort_by"].ecom-collection__sorting-select {
        position: absolute !important;
        inset: 0 !important;
        display: block !important;
        width: 100% !important;
        height: 100% !important;
        min-width: 100% !important;
        min-height: 100% !important;
        opacity: 0 !important;
        cursor: pointer !important;
        z-index: 5 !important;
      }

      @media screen and (max-width: 767px) and (min-width: 101px) {
        body .ecom-collection__product-main.ecom-collection_product_template_collection
          .ecom-collection__product-item .ecom-collection__product-item-information-title,
        body .ecom-collection__product-main.ecom-collection_product_template_collection
          .ecom-collection__product-item .ecom-collection__product-item-information-title a {
          font-size: 14px !important;
        }

        body .ecom-collection__product-main.ecom-collection_product_template_collection
          .ecom-collection__product-item .ecom-collection__product-price,
        body .ecom-collection__product-main.ecom-collection_product_template_collection
          .ecom-collection__product-item .ecom-collection__product-price a,
        body .ecom-collection__product-main.ecom-collection_product_template_collection
          .ecom-collection__product-item .ecom-collection__product-price--regular,
        body .ecom-collection__product-main.ecom-collection_product_template_collection
          .ecom-collection__product-item .ecom-collection__product-price--sale {
          font-size: 15px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function applyEditorialLayout() {
    const roiFeaturedHandles = getFeaturedHandlesFromTheme();
    document.querySelectorAll(gridSelector).forEach(function (grid) {
      let hasFeaturedItem = false;

      Array.from(grid.children).forEach(function (child) {
        if (!(child instanceof HTMLElement) || !child.classList.contains(itemClassName)) {
          return;
        }

        if (cardIsSoldOut(child)) {
          child.dataset.roiSoldOut = 'true';
          delete child.dataset.roiEditorialFeatured;
          return;
        }

        delete child.dataset.roiSoldOut;

        if (roiFeaturedHandles.indexOf(child.getAttribute('data-product-handle')) !== -1) {
          child.dataset.roiEditorialFeatured = 'true';
          hasFeaturedItem = true;
          return;
        }

        if (child.querySelector(flagSelector)) {
          child.dataset.roiEditorialFeatured = 'true';
          hasFeaturedItem = true;
          return;
        }

        delete child.dataset.roiEditorialFeatured;
      });

      if (hasFeaturedItem) {
        grid.dataset.roiEditorialGrid = 'true';
        grid.dataset.roiEditorialColumns = String(getColumnCount(grid));
        return;
      }

      delete grid.dataset.roiEditorialGrid;
      delete grid.dataset.roiEditorialColumns;
    });
  }

  function isVisible(element) {
    if (!(element instanceof HTMLElement)) {
      return false;
    }

    const style = window.getComputedStyle(element);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0'
    );
  }

  function cardIsSoldOut(card) {
    const soldOutBadge = card.querySelector(soldOutBadgeSelector);
    if (isVisible(soldOutBadge)) {
      return true;
    }

    const addToCartButton = card.querySelector(
      '.ecom-collection__product-submit, .ecom-product-single__add-to-cart--submit'
    );

    if (
      addToCartButton &&
      /out\s*stock|unavailable/i.test(addToCartButton.textContent || '')
    ) {
      return true;
    }

    return false;
  }

  function applyCollectionSoldOutLabels() {
    document.querySelectorAll(productCardSelector).forEach(function (card) {
      if (!(card instanceof HTMLElement)) {
        return;
      }

      card.querySelectorAll('.' + soldOutLabelClass).forEach(function (label) {
        label.remove();
      });

      if (!cardIsSoldOut(card)) {
        return;
      }

      const title = card.querySelector(titleSelector);
      if (!(title instanceof HTMLElement)) {
        return;
      }

      const label = document.createElement('div');
      label.className = soldOutLabelClass;
      label.textContent = 'SUR RÉSERVATION';

      const anchorTitle = title.closest('h3') || title;
      anchorTitle.insertAdjacentElement('afterend', label);
    });
  }



  function closestCollectionSortControl(target) {
    if (!(target instanceof Element)) {
      return null;
    }

    return target.closest(
      '.ecom-collection__sortby, .ecom-collection__sort-by, .ecom-collection__sort, ' +
        '.ecom-collection__sortby-wrapper, .ecom-collection__sort-by-wrapper, ' +
        '.ecom-collection__sortby-select, .ecom-collection__sort-select, ' +
        '[class*="ecom"][class*="sort"]'
    );
  }

  function findCollectionSortClickable(control) {
    return control.querySelector(
      'select, button, [role="button"], [aria-haspopup], .ecom-collection__sortby-icon, ' +
        '.ecom-collection__sort-icon, svg'
    );
  }

  function dispatchRealClick(element) {
    ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(function (type) {
      element.dispatchEvent(
        new MouseEvent(type, {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );
    });
  }


  function bindCollectionSortFullClick() {
    if (document.documentElement.dataset.roiSortFullClickBound === 'true') {
      return;
    }

    document.documentElement.dataset.roiSortFullClickBound = 'true';

    document.addEventListener(
      'click',
      function (event) {
        const target = event.target;
        const control = closestCollectionSortControl(target);

        if (!(control instanceof HTMLElement) || control.dataset.roiSortFullClick === 'true') {
          return;
        }

        const interactiveTarget = target.closest('select, button, a, input, [role="button"], [aria-haspopup], svg');
        if (interactiveTarget && control.contains(interactiveTarget)) {
          return;
        }

        const clickable = findCollectionSortClickable(control);
        if (!(clickable instanceof Element) || clickable === target) {
          return;
        }

        control.dataset.roiSortFullClick = 'true';
        if (clickable instanceof HTMLElement && typeof clickable.focus === 'function') {
          clickable.focus();
        }
        dispatchRealClick(clickable);
        window.setTimeout(function () {
          delete control.dataset.roiSortFullClick;
        }, 0);
      },
      true
    );
  }


  function bindCollectionFilterButton() {
    function openFilterModal(button) {
      if (!(button instanceof HTMLButtonElement)) {
        return;
      }

      const container = button.closest('.ecom-collection__filters-container');
      if (!(container instanceof HTMLElement)) {
        return;
      }

      const modal = container.querySelector('.ecom-filter-modal');
      if (!(modal instanceof HTMLElement)) {
        button.click();
        return;
      }

      const coreBlock = modal.closest('div.ecom-core.core__block');
      const coreColumn = modal.closest('div.ecom-column.ecom-core');

      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      modal.style.display = 'block';

      if (coreBlock instanceof HTMLElement) {
        coreBlock.style.zIndex = '99';
      }

      if (coreColumn instanceof HTMLElement) {
        coreColumn.style.zIndex = '99';
      }

      document.body.classList.add('ecom-filter-opened');
    }

    document
      .querySelectorAll(
        '.ecom-collection__filters-wrapper[data-page="collection"] .ecom-collection__filters-container'
      )
      .forEach(function (container) {
        if (!(container instanceof HTMLElement)) {
          return;
        }

        const button = container.querySelector('#button_menu_block.ecom-filter-btn-toggle');
        if (!(button instanceof HTMLButtonElement)) {
          return;
        }

        button.style.pointerEvents = 'auto';

        if (button.dataset.roiFilterButtonBound === 'true') {
          return;
        }

        button.dataset.roiFilterButtonBound = 'true';

        function handleOpen(event) {
          event.preventDefault();
          event.stopPropagation();
          openFilterModal(button);
        }

        button.addEventListener('click', handleOpen, true);

        container.addEventListener(
          'click',
          function (event) {
            const target = event.target;

            if (!(target instanceof Element)) {
              return;
            }

            if (target.closest('.ecom-filter-modal .ecom-modal-content')) {
              return;
            }

            if (target.closest('.ecom-filter-modal-close')) {
              return;
            }

            if (target.closest('#button_menu_block') || target === container) {
              handleOpen(event);
            }
          },
          true
        );

        button
          .querySelectorAll('.ecom-filter-collapse-icon, .ecom-filter-collapse-icon *, span:last-child')
          .forEach(function (target) {
            target.addEventListener('click', handleOpen, true);
          });
      });
  }




  function normalizeMenuLabel(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function applyMenuLabelOverrides() {
    const labelMap = {
      'collection relief': '?dition Reliefs',
      'les non pliables': 'Les pleines tailles',
      'non pliables': 'Les pleines tailles'
    };

    document
      .querySelectorAll('#header a, header a, .header a, .mobile_nav a, .mobile-menu a, nav a')
      .forEach(function (link) {
        if (!(link instanceof HTMLElement)) {
          return;
        }

        const normalized = normalizeMenuLabel(link.textContent);
        const replacement = labelMap[normalized];

        if (!replacement || link.textContent.trim() === replacement) {
          return;
        }

        link.textContent = replacement;
      });
  }

  function normalizeBadgeLabel(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function applyCollectionBadgeLabels() {
    const labelMap = {
      'tres convoite': 'PRISÉ',
      'most coveted': 'PRISÉ',
      'iconic': 'Iconique'
    };

    document
      .querySelectorAll(
        '.ecom-collection__product-item .ecom-collection__product-badge--custom, ' +
          '.ecom-collection__product-item .ecom-collection__product-badge span'
      )
      .forEach(function (badge) {
        if (!(badge instanceof HTMLElement)) {
          return;
        }

        const normalized = normalizeBadgeLabel(badge.textContent);
        const replacement = labelMap[normalized];

        if (!replacement || badge.textContent.trim() === replacement) {
          return;
        }

        badge.textContent = replacement;
      });
  }

  function scheduleApplyEditorialLayout() {
    if (isScheduled) {
      return;
    }

    isScheduled = true;
    requestFrame(function () {
      isScheduled = false;
      applyEditorialLayout();
      applyCollectionSoldOutLabels();
      applyCollectionBadgeLabels();
      applyMenuLabelOverrides();
      bindCollectionFilterButton();
  bindCollectionSortFullClick();
    });
  }

  function shouldReapply(mutations) {
    return mutations.some(function (mutation) {
      if (mutation.type === 'childList') {
        return mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0;
      }

      if (!(mutation.target instanceof Element)) {
        return false;
      }

      return mutation.target.matches(flagSelector) || Boolean(mutation.target.closest(gridSelector));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleApplyEditorialLayout, { once: true });
  } else {
    injectCollectionFinalOverrides();
  scheduleApplyEditorialLayout();
  }

  window.addEventListener('load', scheduleApplyEditorialLayout);
  window.addEventListener('resize', scheduleApplyEditorialLayout);
  document.addEventListener('ecom-products-init', scheduleApplyEditorialLayout, true);
  document.addEventListener('shopify:section:load', scheduleApplyEditorialLayout);

  new MutationObserver(function (mutations) {
    if (shouldReapply(mutations)) {
      scheduleApplyEditorialLayout();
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'hidden']
  });
})();

/* roi-editorial-image-sizes-v2: match responsive image selection to enlarged cards. */
(function () {
  'use strict';
  if (!/\/collections\/[^/]+\/?$/.test(window.location.pathname)) return;

  const collectionSelector = '.ecom-collection__product-main.ecom-collection_product_template_collection';
  const cardSelector = collectionSelector + ' .ecom-collection__product-item[data-roi-editorial-featured="true"]';
  const imageSelector = 'img.ecom-collection__product-media-image, img.ecom-collection__product-secondary-media';
  const originals = new WeakMap();
  const observedImages = new Set();
  const desktopQuery = window.matchMedia('(min-width: 768px)');
  let scheduled = false;
  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;

  function restore(image) {
    if (!originals.has(image)) return;
    const original = originals.get(image);
    if (original === null) image.removeAttribute('sizes');
    else image.setAttribute('sizes', original);
    originals.delete(image);
  }

  function synchronize() {
    scheduled = false;
    const activeImages = new Set();
    if (desktopQuery.matches) {
      document.querySelectorAll(cardSelector).forEach(function (card) {
        const style = window.getComputedStyle(card);
        if (![style.gridColumnStart, style.gridColumnEnd].some(value => /^span\s+([2-9]|\d{2,})$/.test(value))) return;
        card.querySelectorAll(imageSelector).forEach(function (image) {
          if (!image.getAttribute('srcset')) return;
          const width = Math.ceil(image.getBoundingClientRect().width);
          if (width <= 0) return;
          activeImages.add(image);
          if (!originals.has(image)) originals.set(image, image.getAttribute('sizes'));
          const sizes = width + 'px';
          if (image.getAttribute('sizes') !== sizes) image.setAttribute('sizes', sizes);
          if (!observedImages.has(image)) {
            observedImages.add(image);
            if (resizeObserver) resizeObserver.observe(image);
          }
        });
      });
    }
    observedImages.forEach(function (image) {
      if (activeImages.has(image)) return;
      restore(image);
      if (resizeObserver) resizeObserver.unobserve(image);
      observedImages.delete(image);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(synchronize);
  }

  function affectsCollection(mutation) {
    if (mutation.type === 'attributes') {
      return mutation.target instanceof Element && Boolean(mutation.target.closest(collectionSelector));
    }
    return [...mutation.addedNodes, ...mutation.removedNodes].some(function (node) {
      return node instanceof Element && (node.matches(cardSelector) || node.matches(imageSelector) || Boolean(node.querySelector(cardSelector + ', ' + imageSelector)));
    });
  }

  new MutationObserver(function (mutations) {
    if (mutations.some(affectsCollection)) schedule();
  }).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['data-roi-editorial-featured', 'srcset'],
  });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('ecom-products-init', schedule, true);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();
